var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightprimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    width: 17,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.087 9.01a.958.958 0 0 1-.267.666l-5.585 5.789a.887.887 0 0 1-1.286 0 .967.967 0 0 1 0-1.334L9.891 9.01 4.949 3.889a.967.967 0 0 1 0-1.334.887.887 0 0 1 1.287 0l5.585 5.789a.958.958 0 0 1 .266.666z",
    fill: "#6a4ff5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightprimary);
export default __webpack_public_path__ + "static/media/arrow-right.primary.46bff856bb4e8dbba045bb7520cbb83c.svg";
export { ForwardRef as ReactComponent };